import { createSelector } from 'reselect'

export const getRoleId = (state, props) => props.roleId

export const getUserRoles = (state, props) => state.kanbo.userRoles

export const usersSelector = createSelector(
  [getRoleId, getUserRoles],
  (roleId, userRoles) =>
    Object.keys(userRoles)
      .filter(key => userRoles[key].find(role => role === roleId))
      .map(key => Number(key))
)

export default createSelector(
  [
    usersSelector,
  ],
  (
    users,
  ) => ({
    users,
  })
)
